const WA_LINK =
  "https://wa.me/5493415779623?text=Hola!%20Quiero%20reservar%20para%20ir%20a%20la%20Formaci%C3%B3n%20de%20Pergamino%20en%20La%20Usina%20Norte";

export default function Navbar() {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-black/90 backdrop-blur-sm shadow-md">
      <div className="container mx-auto px-6 py-4">
        <div className="flex flex-row items-center justify-between gap-2">
          <a className="flex items-center cursor-pointer" href="/">
            <img
              alt="MenteIA"
              className="h-12 md:h-24 w-auto"
              src="https://static.readdy.ai/image/9d306f0d392a82ba4f7ef7b5bf276da1/6b7028e86d250b4304b766fd8606cb84.png"
            />
          </a>

          <div className="flex items-center">
            <img
              alt="Elevora"
              className="h-12 md:h-24 w-auto"
              src="https://static.readdy.ai/image/9d306f0d392a82ba4f7ef7b5bf276da1/b435312bc64b669d54cf6d857c010a1e.png"
            />
          </div>

          <div className="flex items-center gap-6">
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 md:px-6 md:py-2.5 rounded-lg font-medium text-sm md:text-base transition-all duration-300 whitespace-nowrap cursor-pointer bg-teal-500 text-white hover:bg-teal-400 hover:scale-110 hover:shadow-lg hover:shadow-teal-500/50"
            >
              Reservar
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}
